/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export class AuthenticationPersistenceKey {
  static readonly AUTHENTICATION_TOKEN = 'kit-authentication/persistence/authentication-token';
  static readonly AUTHENTICATION_TIME = 'kit-authentication/persistence/authentication-time';
  static readonly AUTHENTICATION_TIMEOUT = 'kit-authentication/persistence/authentication-timeout';
}
